<app-verify-with-otp [useContextContact]="true" #verifyOtpComponent
                     [requestOtpEndpoint]="requestEndpoint"
                     [requestOtpBody]="requestBody"
                     [errMessage]="errMessage"
                     (otpVerified)="onVerify($event)"
></app-verify-with-otp>
